const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 636 636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M636,381.8v-128l-92.7-12.6c-3.3-9.8-7.3-19.3-11.9-28.5l56.5-74.4-90.5-90.5-74.5,56.6c-9.2-4.5-18.7-8.5-28.6-11.8L381.8,0h-128l-12.6,92.7c-9.8,3.3-19.3,7.3-28.5,11.9l-74.4-56.5-90.5,90.5,56.6,74.5c-4.5,9.2-8.5,18.7-11.8,28.6L0,254.2v128l92.7,12.6c3.3,9.8,7.3,19.3,11.9,28.5l-56.5,74.4,90.5,90.5,74.5-56.6c9.2,4.5,18.7,8.5,28.6,11.8l12.6,92.5h128l12.6-92.7c9.8-3.3,19.3-7.3,28.5-11.9l74.4,56.5,90.5-90.5-56.6-74.5c4.5-9.2,8.5-18.7,11.8-28.6l92.5-12.6ZM318,461c-79,0-143-64-143-143s64-143,143-143,143,64,143,143-64,143-143,143Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.f04136f9a76e1d05d899a56446e27629.svg";
export { ForwardRef as ReactComponent };